<div class="content" *ngIf="inventory">
    <div class="d-flex justify-content-start">

        <div (click)="goToInventoryView()" style="cursor: pointer;">
            <div class="d-flex align-items-center">
                <i class="fa-solid fa-arrow-left"></i>
                <span>Back to Inventory View</span>
            </div>
        </div>
    </div>


    <div class="d-flex justify-content-center mt-4">
        <div class="row">
            <h3>{{inventory.productName}}</h3>
        </div>
    </div>
    <div class="d-flex justify-content-center mt-4">

        <label>Order Date: </label>
        <span style="margin-left: 0.5%;">{{inventory.orderDate}}</span>
    </div>
    <div class="d-flex justify-content-center mt-2">
        <label>Activation Date: </label>
        <span style="margin-left: 0.5%;">{{inventory.activationDate}}</span>
    </div>
    <div class="d-flex justify-content-center mt-2">
        <label>Termination Date:</label>
        <span style="margin-left: 0.5%;">{{inventory.terminationDate}}</span>

    </div>
    <div class="d-flex justify-content-center mt-2">

        <label for="msisdn">MSISDN: </label>
        <span style="margin-left: 0.5%;" id="msisdn">{{inventory.msisdn}}</span>
    </div>
    <div class="d-flex justify-content-center mt-2">
        <label>ICCID:</label>
        <span style="margin-left: 0.5%;">{{inventory.iccid}}</span>






    </div>

    <div class="d-flex justify-content-center mt-4">

        <ng2-smart-table [settings]="settings" [source]="listRelationship">
        </ng2-smart-table>


    </div>

    <div class="d-flex justify-content-center mt-4" *ngIf="viewHandset()">

        <ng2-smart-table [settings]="settingsHandset" [source]="listHandset">
        </ng2-smart-table>


    </div>

</div>